export default "__VITE_PUBLIC_ASSET__82c12e49__"